import React from "react";
import { SELECTED_ELEMENT_COLOR } from "../configuratorConstants";
import { ReactComponent as DoorSvg } from "../../Assets/door.svg";

const DoorRenderer = ({ element, scale, isSelected, wallThickness, placementSideFactor, jointPosition }) => {
  const {
    width: doorSegmentWidthM,
    hingeSide = "left",
    openingDirection = "outward"
  } = element;

  const SVG_VIEWBOX_WIDTH_UNITS = 80.924862;
  const SVG_VIEWBOX_HEIGHT_UNITS = 83.359993;

  const FUDGE_TRANSLATE_X_SVG = 42.5;
  const FUDGE_TRANSLATE_Y_SVG = -10;

  const screenJambLengthPx = doorSegmentWidthM * scale;
  const svgInternalScaleFactor = screenJambLengthPx / SVG_VIEWBOX_HEIGHT_UNITS;

  const screenSvgWidthPx = SVG_VIEWBOX_WIDTH_UNITS * svgInternalScaleFactor;
  const screenSvgHeightPx = SVG_VIEWBOX_HEIGHT_UNITS * svgInternalScaleFactor;

  const wallThicknessPx = wallThickness * scale;

  let doorContainerTransform = `translate(${-screenJambLengthPx * 1.0}, ${-wallThicknessPx / 4}) rotate(-90)`;

  const fudgeTranslateAlongWallPx =
    FUDGE_TRANSLATE_Y_SVG * svgInternalScaleFactor;
  if (fudgeTranslateAlongWallPx !== 0) {
    doorContainerTransform += ` translate(${fudgeTranslateAlongWallPx}, 0)`;
  }

  const scaleX = openingDirection === "inward" ? -1 : 1;
  const scaleY = hingeSide === "right" ? -1 : 1;

  let translateX = 0;
  let translateY = 0;

  if (openingDirection === "inward") {
      const КОЭФФИЦИЕНТ_СДВИГА_ВСЕРЕДИНУ = -0.15;
      translateX = КОЭФФИЦИЕНТ_СДВИГА_ВСЕРЕДИНУ * screenSvgWidthPx;
  }
  
  // --- НАЧАЛО ИСПРАВЛЕНИЯ ---
  // Убираем сложную и неточную формулу с "магическим числом".
  // Теперь, если дверь отражается (hingeSide === 'right'), мы сдвигаем её
  // обратно на её собственную визуальную ширину, чтобы она осталась на месте.
  if (hingeSide === "right") {
    // После поворота на -90 градусов, "высота" SVG становится его шириной на плане.
    // Множитель 1.05 используется при рендеринге SVG, поэтому мы учитываем его.
    translateY = -screenSvgHeightPx * 2.03;
  }
  // --- КОНЕЦ ИСПРАВЛЕНИЯ ---

  doorContainerTransform += ` scale(${scaleX}, ${scaleY}) translate(${translateX}, ${translateY})`;

  const fudgeTranslatePerpendicularPx =
    FUDGE_TRANSLATE_X_SVG * svgInternalScaleFactor;
  if (fudgeTranslatePerpendicularPx !== 0) {
    doorContainerTransform += ` translate(0, ${fudgeTranslatePerpendicularPx})`;
  }

  const svgStyle = {
    fill: isSelected ? "rgba(0, 123, 255, 0.15)" : "rgba(220, 220, 225, 0.85)",
    stroke: isSelected ? SELECTED_ELEMENT_COLOR : "rgba(60, 70, 80, 0.95)",
    strokeWidth: Math.max(0.5, 1.0 / svgInternalScaleFactor),
  };

  return (
    <g transform={doorContainerTransform}>
      <DoorSvg
        width={screenSvgWidthPx * 1.2}
        height={screenSvgHeightPx * 1.05}
        preserveAspectRatio="none"
        style={svgStyle}
      />
    </g>
  );
};

export default React.memo(DoorRenderer);